(() => {
 if (customElements.get('aji-sale-badge')) return;
 class SaleBadge extends HTMLElement {
  connectedCallback() { this.refresh(); }
  refresh() {
   const price = Number(this.dataset.price), compare = Number(this.dataset.compare);
   const sale = this.dataset.enabled !== 'false' && Number.isFinite(price) && Number.isFinite(compare) && compare > price && compare > 0 && price >= 0;
   this.hidden = !sale;
   if (sale) this.textContent = (this.dataset.pattern || 'On sale {percent}%').replaceAll('{percent}', String(Math.floor((compare - price) * 100 / compare)));
  }
  setVariant(variant) { this.dataset.price = String(variant.price || 0); this.dataset.compare = String(variant.compare_at_price || 0); this.refresh(); }
 }
 customElements.define('aji-sale-badge', SaleBadge);
 document.addEventListener('theme:variant:change', event => {
  const root = event.detail?.productRootEl, variant = event.detail?.variant;
  if (root && variant) root.querySelectorAll('aji-sale-badge').forEach(badge => badge.setVariant(variant));
 });
 document.addEventListener('variant-buttons-display-change', event => {
  const root = event.target.closest('.aji-product-tile, .product-tile--mini') || event.target.querySelector('.aji-product-tile, .product-tile--mini');
  const key = event.detail?.key;
  if (!root || !['currentVariantPrice', 'currentVariantCompareAtPrice'].includes(key)) return;
  root.querySelectorAll('aji-sale-badge').forEach(badge => {
   badge.dataset[key === 'currentVariantPrice' ? 'price' : 'compare'] = String(event.detail.value || 0);
   requestAnimationFrame(() => badge.refresh());
  });
 }, true);
})();
